
/**
 * Adzuki.ToggleableSection
 * persistent collapsing/expanding sections
 */

(function ToggleableSection($, Adzuki)
{
	"use strict";

	var toggle = function ToggleableSection(el)
	{
		var self = this;

		try
		{
			if (el instanceof jQuery) {
				this.$el = el;
			} else {
				this.$el = $(el);
			}

			if (!this.$el.length) {
				throw new Error('cannot find ' + el);
			}

			this.expandedClass  = Adzuki.FaIcon.getIconStyle('collapse', 'regular');
			this.collapsedClass = Adzuki.FaIcon.getIconStyle('expand', 'regular');

			// cookie set = collapsed; no cookie = expanded
			this.$el.each(function _setupToggleableState(i, dom_el)
			{
				var $self   = $(this),
				    target  = $self.data('target'),
				    $target = $(target),
				    cookie  = $self.data('cookie'),
				    _cookie = Cookies.get(cookie);

				if (!$target.length) {
					throw new Error('cannot find target '+target);
				}

				// check for required collapse class on target
				if (!$target.hasClass('collapse')) {
					throw new Error('target '+target+' missing "collapse" class');
				}

				// check for icon overrides
				if ($self.data('expand-icon')) {
					self.expandedClass = $self.data('expand-icon');
				}

				if ($self.data('collapse-icon')) {
					self.collapsedClass = $self.data('collapse-icon');
				}

				// if cookie set, means its collapsed
				if (_cookie !== undefined && $self.hasClass(self.expandedClass)) {
					$self.removeClass(self.expandedClass).addClass(self.collapsedClass);
				}

				// set state on events
				$target.on('shown.bs.collapse', function _shown() {
					$self.removeClass(self.collapsedClass).addClass(self.expandedClass);
					Cookies.remove(cookie);
				}).on('hidden.bs.collapse', function _hidden() {
					$self.removeClass(self.expandedClass).addClass(self.collapsedClass);
					Cookies.set(cookie, 1);
				});
			});
		}
		catch (err)
		{
			console.log('[Adzuki.ToggleableSection]', err);
		}
	};

	Adzuki.ToggleableSection = toggle;
}(jQuery, window.Adzuki || {}));
